/** Autogenerated by public2business schematic. DO NOT CHANGE! */
/* tslint:disable */
import { NgModule } from '@angular/core';

import { SbbTimeInput } from './time-input/time-input.directive';

@NgModule({
  declarations: [SbbTimeInput],
  exports: [SbbTimeInput],
})
export class SbbTimeInputModule {}
